// Stüdyo başlangıç tasarımları. Marka kimliğine özel setler (Kixz, Juju Mood) + her markaya boş başlangıç.
// Kixz setinin kaynağı: glowytics-backend/var/kixz_email/build.py (api.glowytics.com/pixel/kixz-email/).
// Juju ürünleri: glowytics-backend/var/juju_email/products.py (Merchant Center anlık görüntüsü).
// Yorstruly ürünleri: glowytics-backend/var/yorstruly_email/products.py (Shopify anlık görüntüsü).
import { uid, DEFAULT_THEME } from './emailDoc';
import PR from './kixzProducts';
import JPR from './jujuProducts';
import YPR, { LIFE as YLIFE } from './yorstrulyProducts';

const KIXZ_ID = '6e38ac10-35a4-49e3-9f71-d5d08f8ad20c';
const IMG = 'https://api.glowytics.com/pixel/kixz-email/img/';
const U = (path) => `https://kixz.com/${path}`;

export const KIXZ_THEME = {
  ...DEFAULT_THEME,
  logo: `${IMG}kixz-logo-black.png`,
  logoFooter: `${IMG}kixz-logo-white.png`,
  logoWidth: 96,
  homeUrl: U(''),
  radius: 0,
  headFont: 'Anton',
  nav: [{ label: 'Krampon', url: U('krampon') }, { label: 'Halı saha', url: U('hali-saha-kramponlari-tf') }, { label: 'Forma', url: U('forma') }],
  footerLinks: [{ label: 'Instagram', url: 'https://www.instagram.com/kixzcom/' }, { label: 'kixz.com', url: U('') }],
  footerText: "Bu e-postayı kixz.com'dan ticari ileti almayı kabul ettiğin için alıyorsun.",
};

// Her çağrıda taze kopya + yeni blok kimlikleri (aynı başlangıçtan iki şablon açılabilsin)
const clone = (o) => JSON.parse(JSON.stringify(o));
const B = (type, fields) => ({ id: uid(), type, ...clone(fields) });
const P = (k) => clone(PR[k]);
const items = (...pairs) => pairs.map(([k, label]) => ({ item: P(k), label: label || '' }));

const KIXZ = [
  {
    key: 'ilk-siparis', name: '01 Yaşam döngüsü: Kramponun ilk antrenmana hazır mı?', group: 'Lifecycle · New customers (30 days)',
    subject: 'Kramponun ilk antrenmana hazır mı?', preheader: 'Uzun ömür için üç küçük alışkanlık ve eksik kalan parçalar',
    blocks: () => [
      B('hero', { bg: 'white', eyebrow: 'Siparişin teslim edildi', title: '{{first_name|Selam}}, kramponun\nsahaya hazır', text: '{{son_krampon|Mercurial Vapor 16 Academy}} artık senin. İlk birkaç antrenmanda ayağına göre şekillenecek; aşağıdaki üç alışkanlık ömrünü uzatır.', button: { label: '', url: '' }, titleSize: 46 }),
      B('image', { item: P('VP16_ACA'), crop: 'wide', url: '' }),
      B('steps', { bg: 'soft', title: 'Uzun ömür için üç alışkanlık', items: [
        { title: 'Maçtan sonra çamurunu kurumadan al', text: 'Yumuşak fırça ve ılık su yeterli. Deterjan ve makine yıkama üst yüzeyi bozar.' },
        { title: 'Kalorifer ve güneşte kurutma', text: 'İçine gazete kâğıdı koy, oda sıcaklığında kurusun. Sıcak hava yapıştırıcıyı gevşetir.' },
        { title: 'Zemine uygun taban', text: 'FG tabanı çimde, TF tabanı halı sahada kullan. Yanlış zemin dişleri erken aşındırır.' }] }),
      B('products', { bg: 'white', title: 'Çantada eksik kalmasın', items: items(['SOCK'], ['SHIN']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Ekipmanlara göz at', url: U('ekipman') }),
    ],
  },
  {
    key: 'takim-tamamla', name: '02 Futbol çapraz satış: Krampon tamam, peki tekmelik?', group: 'Cross-sell · Boots, no shin guards',
    subject: 'Krampon tamam, peki tekmelik?', preheader: 'Kramponuna uyan çorap, tekmelik ve top',
    blocks: () => [
      B('hero', { bg: 'soft', eyebrow: 'Takımını tamamla', title: 'Krampon tamam.\nGerisi?', text: '{{son_krampon|Superfly 10 Academy}} kramponunu aldın; tekmelik, kaydırmaz çorap ve top henüz sepetine girmedi. Kramponunla aynı seriden seçtik.', button: { label: '', url: '' }, titleSize: 46 }),
      B('products', { bg: 'white', title: '', items: items(['SHIN', 'Henüz almadın'], ['GRIP', 'Henüz almadın'], ['SOCK', 'Henüz almadın'], ['BALL', 'Henüz almadın']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Hepsini gör', url: U('ekipman') }),
    ],
  },
  {
    key: 'ust-seviye', name: '03 Krampon profili: Aynı seri, bir üst seviye', group: 'Boot profile · Upgrade candidates',
    subject: 'Aynı seri, bir üst seviye', preheader: 'Academy ile Elite arasındaki fark ve bugünkü fiyat farkı',
    blocks: () => [
      B('hero', { bg: 'white', eyebrow: 'Bir üst seviye', title: '{{seri|Superfly}} ailesinde\nbir adım yukarı', text: 'Bugüne kadar hep {{seviye|Academy}} seviyesinde oynadın. Elite, aynı kalıbın profesyonellerin giydiği versiyonu. Farkı yan yana koyduk.', button: { label: '', url: '' }, titleSize: 46 }),
      B('compare', { a: P('SF10_ACA'), b: P('SF10_ELI'), labelA: 'Şu an ayağındaki seviye', labelB: 'Bir üst seviye', buyLabel: 'Satın al', rows: [
        ['Seviye', 'Academy', 'Elite'], ['Zemin', 'FG/MG (çim + suni çim)', 'FG (çim)'],
        ['Kimin için', 'Hızını bir üst seviyeye taşımak isteyen', 'Maksimum hız ve patlayıcı ivme arayan'],
        ['Bugünkü fiyat', '3.849,30 TL', '14.449,15 TL']] }),
      B('button', { bg: 'white', label: "Elite'i incele", url: PR.SF10_ELI.url }),
    ],
  },
  {
    key: 'yeni-model', name: '04 Krampon profili: Superfly 11 geldi', group: 'Boot profile · Silo wearers',
    subject: 'Superfly 11 geldi', preheader: "Mercurial giyenlere ilk haber: yeni nesil Superfly kixz.com'da",
    blocks: () => [
      B('hero', { bg: 'ink', eyebrow: '{{seri|Mercurial}} giyenlere ilk haber', title: '{{model|Superfly 11 Elite}}', text: "Son kramponun {{son_krampon|Superfly 10}} idi. Yeni nesil bugün kixz.com'da; numaralar hızlı tükeniyor.", button: { label: 'Numaranı seç', url: PR.SF11_ELI.url }, titleSize: 64 }),
      B('image', { item: P('SF11_ELI'), crop: 'wide', url: '' }),
      B('products', { bg: 'white', title: '{{seri|Mercurial}} serisinde diğerleri', items: items(['SF10_LV8'], ['VP16_ELI']), buyLabel: 'Satın al' }),
    ],
  },
  {
    key: 'krampon-yenileme', name: '05 Krampon profili: Kramponun 6 ayı doldurdu', group: 'Boot profile · Replacement due',
    subject: 'Kramponun 6 ayı doldurdu', preheader: 'Düzenli oynayanlar için bir dakikalık kontrol ve serindeki yeni modeller',
    blocks: () => [
      B('hero', { bg: 'white', eyebrow: 'Yenileme zamanı', title: '{{krampon_yasi|7 ay}} oldu', text: '{{son_krampon|Phantom 6 Low Academy}} kramponunu {{son_krampon_ay|Mart}} ayında aldın. Düzenli oynuyorsan dişleri ve tabanı kontrol etme zamanı.', button: { label: '', url: '' }, titleSize: 46 }),
      B('steps', { bg: 'soft', title: 'Bir dakikalık kontrol', items: [
        { title: 'Dişlere bak', text: 'Uçlar yuvarlaklaştıysa kayma artar, dönüşlerde tutuş azalır.' },
        { title: 'Tabanı bük', text: 'Ön kısım eskisinden kolay katlanıyorsa plaka yorulmuştur.' },
        { title: 'Burnu ve topuğu kontrol et', text: 'Dikiş açılması ve topukta yırtılma değişim zamanının işaretidir.' }] }),
      B('products', { bg: 'white', title: '{{seri|Phantom}} serisinde şimdi', items: items(['PH6_ELI', 'Bir üst seviye'], ['PH6_HA', 'Aynı seviye']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Tüm kramponlar', url: U('krampon') }),
    ],
  },
  {
    key: 'cocuk-numara', name: '06 Krampon profili: Bir numara büyüdü mü?', group: "Boot profile · Kids' boots",
    subject: 'Bir numara büyüdü mü?', preheader: 'Evde iki dakikada ölç, doğru numarayı seç',
    blocks: () => [
      B('hero', { bg: 'soft', eyebrow: 'Ebeveynler için', title: 'Bir numara\nbüyüdü mü?', text: '{{cocuk_krampon_ay|Mayıs}} ayında {{cocuk_numara|33 numara}} çocuk kramponu aldın. Çocukların ayağı hızlı büyür; dar krampon hem oyunu hem ayağı zorlar. Evde iki dakikada ölçebilirsin.', button: { label: '', url: '' }, titleSize: 46 }),
      B('steps', { bg: 'white', title: '', items: [
        { title: 'Kâğıdın üstüne bastır', text: 'Akşam saatinde, çorapla, topuk duvara değecek şekilde.' },
        { title: 'Topuk ile en uzun parmak arasını ölç', text: 'Santimetre olarak not al.' },
        { title: 'Bir parmak boşluk bırak', text: 'Ölçüye yaklaşık 1 cm ekleyip ürün sayfasındaki beden tablosundan numarayı bul.' }] }),
      B('products', { bg: 'white', title: 'Çocuk kramponları', items: items(['K_SF'], ['K_VINI'], ['K_TM'], ['K_PH']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Çocuk kramponları', url: U('cocuk-krampon') }),
    ],
  },
  {
    key: 'yeni-sezon-forma', name: '07 Taraftar profili: Barcelona 2026/27 formaları geldi', group: 'Fan profile · Last season kit',
    subject: 'Barcelona 2026/27 formaları geldi', preheader: "İç saha, üçüncü forma ve çocuk forması kixz.com'da",
    blocks: () => [
      B('hero', { bg: '#a50044', eyebrow: '2026/27 sezonu', title: '{{kulup|Barcelona}}\nyeni sezon', text: 'Geçen sezon {{son_forma|Barcelona 2025/26 İç Saha}} formasını aldın. Yeni sezonun formaları geldi.', button: { label: 'Formaları gör', url: U('barcelona-formasi') }, titleSize: 58 }),
      B('products', { bg: 'white', title: '', items: items(['BAR_H', 'İç saha'], ['BAR_3', 'Üçüncü forma'], ['BAR_K', 'Çocuk'], ['BAR_T', 'Antrenman']), buyLabel: 'Satın al' }),
    ],
  },
  {
    key: 'hali-saha', name: '08 Krampon profili: Hafta içi halı saha için', group: 'Boot profile · Grass players',
    subject: 'Hafta içi halı saha için', preheader: 'Çim kramponuyla halı sahaya çıkma; TF taban farkı ve seçenekler',
    blocks: () => [
      B('hero', { bg: 'white', eyebrow: 'Kış sezonu', title: 'Çim kramponu\nhalı sahaya çıkmaz', text: 'Hava soğudu, maçlar halı sahaya taşınıyor. FG dişleri halı sahada tutmaz ve hızlı aşınır; TF tabanın kısa, sık kauçuk dişleri bu zemin için yapıldı. {{seri|Phantom}} giyiyorsan aynı kalıbın TF versiyonundan başla.', button: { label: '', url: '' }, titleSize: 46 }),
      B('products', { bg: 'white', title: '', items: items(['PH6_TF', 'Senin serin'], ['MUNDIAL', 'Klasik'], ['PRED_TF', 'Kontrol'], ['F50_TF', 'Hız']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Halı saha ayakkabıları', url: U('hali-saha-kramponlari-tf') }),
    ],
  },
];

// ── Juju Mood ───────────────────────────────────────────────────────────────
// Segmentler Shopify siparişlerinden (Oca 2025 – Mar 2026). Ürün bilgisi yalnız jujumood.com açıklamalarından;
// indirim/kod uydurulmadı, fiyatlar MC'deki güncel satış fiyatı.
const JUJU_ID = 'a431e51f-1154-45f9-9b0b-b07f0f39a80b';
const JIMG = `https://api.glowytics.com/pixel/glowymail/${JUJU_ID}/`;
const JU = (path) => `https://jujumood.com/${path}`;

export const JUJU_THEME = {
  ...DEFAULT_THEME,
  logo: `${JIMG}juju-logo-bordo.png`,
  logoFooter: `${JIMG}juju-logo-white.png`,
  logoWidth: 110,
  homeUrl: JU(''),
  ink: '#8a2432',
  soft: '#f7f2ef',
  muted: '#7d6b6d',
  line: '#ece2df',
  accent: '#8a2432',
  radius: 0,
  headFont: 'Jost',
  uppercaseHeadings: false,
  nav: [{ label: 'Bileklik', url: JU('collections/bileklikler') }, { label: 'Kolye', url: JU('collections/kolyeler') }, { label: 'Küpe', url: JU('collections/kupeler') }, { label: 'Yüzük', url: JU('collections/yuzukler') }],
  footerLinks: [{ label: 'jujumood.com', url: JU('') }],
  footerMuted: '#e3c9cd',  // bordo zeminde gri okunmuyor
  footerText: "Bu e-postayı jujumood.com'dan ticari ileti almayı kabul ettiğin için alıyorsun.",
};

const JP = (k) => clone(JPR[k]);
const jitems = (...pairs) => pairs.map(([k, label]) => ({ item: JP(k), label: label || '' }));

const JUJU = [
  {
    key: 'ilk-siparis', name: "01 Yaşam döngüsü: JUJU'n artık seninle", group: 'Lifecycle · New customers (30 days)',
    subject: "JUJU'n uzun süre ilk günkü gibi kalsın", preheader: 'El yapımı bronz parçalar için üç küçük not',
    blocks: () => [
      B('hero', { bg: 'white', eyebrow: 'Siparişin için teşekkürler', title: "{{first_name|Selam}}, JUJU'n\nartık seninle", text: '{{son_urun|Taşlı Mini Square Bileklik}} el yapımı bronzdan. Aşağıdaki üç not uzun süre ilk günkü gibi kalmasına yardımcı olur.', button: { label: '', url: '' }, titleSize: 44 }),
      B('image', { item: JP('T_MINI_SQ'), crop: 'wide', url: '' }),
      B('steps', { bg: 'soft', title: 'Bakım için üç not', items: [
        { title: 'Parfümle temas ettirme', text: 'Bronz parçaları parfümden uzak tut; parfümünü sürdükten sonra JUJU’nu tak.' },
        { title: 'Denizde, havuzda çıkarmana gerek yok', text: 'JUJU parçaları suda ve denizde kullanılabilir.' },
        { title: 'Kilidi bileğine göre ayarla', text: 'Bileklik kilitleri ayarlanabilir; sıkmadan, rahat oturacak kadar çek.' }] }),
      B('products', { bg: 'white', title: 'Yanına yakışanlar', items: jitems(['MINI_SQ'], ['T_ROPE']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Bilekliklere göz at', url: JU('collections/bileklikler') }),
    ],
  },
  {
    key: 'bileklik-esi', name: '02 Çapraz satış: Bileklik tamam, ya gerisi?', group: 'Cross-sell · Bracelets only, no necklace/earring/ring',
    subject: 'Bilekliğinin yanına bir küpe, bir kolye', preheader: 'Küpe, kolye ve yüzüklerde en çok tercih edilenler',
    blocks: () => [
      B('hero', { bg: 'soft', eyebrow: 'Kombinini tamamla', title: 'Bileklik tamam.\nYa gerisi?', text: "Bugüne kadar JUJU'dan hep bileklik aldın; en son {{son_urun|Mini Square Bileklik}}. Küpe, kolye ve yüzüklerimizden en çok tercih edilenleri seçtik.", button: { label: '', url: '' }, titleSize: 44 }),
      B('products', { bg: 'white', title: '', items: jitems(['T_TRI', 'Küpe'], ['BEE', 'Küpe'], ['CYL', 'Kolye'], ['HB_Y', 'Yüzük']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Küpelere göz at', url: JU('collections/kupeler') }),
    ],
  },
  {
    key: 'kombin', name: '03 Kombin: Bir bileklik güzel, üst üste daha güzel', group: 'Stacking · Single bracelet buyers',
    subject: 'Bir bileklik güzel, üst üste daha güzel', preheader: 'JUJU bileklikleriyle kendi setini kur',
    blocks: () => [
      B('hero', { bg: 'white', eyebrow: 'Kendi setini kur', title: 'Tek başına güzel.\nÜst üste daha güzel', text: 'JUJU bileklikleri tek tek kullanabileceğin gibi birbiriyle uyumlu setler de kurabilirsin. {{son_urun|Taşlı Mini Square Bileklik}} bilekliğinin yanına dört öneri:', button: { label: '', url: '' }, titleSize: 44 }),
      B('products', { bg: 'white', title: '', items: jitems(['T_MINI_SQ', 'Taşlı'], ['MINI_SQ', 'Sade'], ['T_ROPE', 'İp'], ['ROUND', 'İnce']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Tüm bileklikler', url: JU('collections/bileklikler') }),
    ],
  },
  {
    key: 'isim', name: '04 Kişiye özel: Bir isim, bir tarih ya da bir motto', group: 'Personalised · Repeat buyers, no name piece yet',
    subject: 'Bir isim, bir tarih ya da bir motto', preheader: 'JUJU isim bilekliklerine istediğini işle',
    blocks: () => [
      B('hero', { bg: '#8a2432', eyebrow: 'Kişiye özel', title: 'Sadece adın değil', text: 'Sevdiklerinin isimlerini, hayatındaki anlamlı bir tarihi ya da sana ilham veren bir mottoyu bilekliğine işle. İster kendin için, ister sevdiğin birine hediye olarak.', button: { label: 'Kişiselleştir', url: JU('collections/kisisellestirilebilir-urunler') }, titleSize: 48 }),
      B('image', { item: JP('ISIM_B'), crop: 'wide', url: '' }),
      B('products', { bg: 'white', title: '', items: jitems(['ISIM_B', 'Bileklik'], ['ISIM_IP', 'İp bileklik'], ['ISIM_K', 'Kolye'], ['ISIM_TK', 'Kolye']), buyLabel: 'Satın al' }),
    ],
  },
  {
    key: 'yilbasi-hediye', name: '05 Hediye: Yılbaşı listesi', group: 'Gifting · Bought in December 2025',
    subject: 'Yılbaşı listen hazır mı?', preheader: 'Küçük dokunuşlardan kalıcı hediyelere, bir de hediye kartı',
    blocks: () => [
      B('hero', { bg: 'soft', eyebrow: 'Yılbaşı hediyesi', title: 'Geçen yılbaşı\nJUJU seçtin', text: "Geçen Aralık'ta JUJU'dan alışveriş yaptın. Bu yıl için listeyi hazırladık.", button: { label: '', url: '' }, titleSize: 44 }),
      B('products', { bg: 'white', title: 'Küçük dokunuşlar', items: jitems(['ROUND'], ['T_ROPE']), buyLabel: 'Satın al' }),
      B('products', { bg: 'white', title: 'Unutulmayacak hediyeler', items: jitems(['ISIM_B', 'Kişiye özel'], ['LUC_K']), buyLabel: 'Satın al' }),
      B('hero', { bg: 'soft', eyebrow: 'Karar veremeyenlere', title: 'JUJU hediye kartı', text: 'Hediye kartları dijital. Tutarı sen seçersin, parçayı o seçer.', button: { label: 'Hediye kartı', url: JPR.GIFT.url }, titleSize: 36 }),
    ],
  },
  {
    key: 'yeni-gelenler', name: '06 Geri kazanım: Son siparişinden bu yana gelenler', group: 'Win-back · No order in 9+ months',
    subject: 'Son siparişinden bu yana neler geldi', preheader: 'Sierra, Slate, Sentry ve Ardent: koleksiyona yeni eklenenler',
    blocks: () => [
      B('hero', { bg: 'white', eyebrow: 'Yeni gelenler', title: 'Son siparişinden\nbu yana', text: 'En son {{son_siparis_ay|Ocak}} ayında alışveriş yaptın. O günden bu yana koleksiyona yeni parçalar eklendi; birkaçını seçtik.', button: { label: '', url: '' }, titleSize: 44 }),
      B('image', { item: JP('SIERRA'), crop: 'wide', url: '' }),
      B('products', { bg: 'white', title: '', items: jitems(['SIERRA'], ['SLATE'], ['SENTRY'], ['ARDENT']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Tüm yeni gelenler', url: JU('collections/new') }),
    ],
  },
  {
    key: 'kolyene-bileklik', name: '07 Çapraz satış: Kolyenin bir de bilekliği var', group: 'Cross-sell · Necklace only, no bracelet',
    subject: 'Kolyenin bir de bilekliği var', preheader: 'Lucien ve Soren ailelerinde kolye ile bileklik aynı tasarım',
    blocks: () => [
      B('hero', { bg: 'soft', eyebrow: 'Aynı aileden', title: 'Kolyenin\nbir de bilekliği var', text: "JUJU'dan kolye aldın ama henüz bileklik almadın. Lucien ve Soren ailelerinde kolye ile bileklik aynı tasarımdan geliyor.", button: { label: '', url: '' }, titleSize: 44 }),
      B('products', { bg: 'white', title: 'Lucien', items: jitems(['LUC_K', 'Kolye'], ['LUC_B', 'Bileklik']), buyLabel: 'Satın al' }),
      B('products', { bg: 'white', title: 'Soren', items: jitems(['SOR_K', 'Kolye'], ['SOR_B', 'Bileklik']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Tüm bileklikler', url: JU('collections/bileklikler') }),
    ],
  },
  {
    key: 'heartbeat', name: "08 Ürün ailesi: Heartbeat'in yüzüğü ve küpesi", group: 'Product family · Heartbeat bracelet owners',
    subject: "Heartbeat'in bir de yüzüğü ve küpesi var", preheader: 'Bilekliğinle aynı tasarım: Heartbeat Yüzük ve Heartbeat Küpe',
    blocks: () => [
      B('hero', { bg: 'white', eyebrow: 'Heartbeat ailesi', title: 'Bilekliğinle\naynı ritimde', text: 'Heartbeat Bileklik senin. Aynı tasarımın yüzüğü ve küpesi de var; üçü birlikte bir set oluyor.', button: { label: '', url: '' }, titleSize: 44 }),
      B('image', { item: JP('HB_B'), crop: 'wide', url: '' }),
      B('products', { bg: 'white', title: '', items: jitems(['HB_Y', 'Yüzük'], ['HB_K', 'Küpe']), buyLabel: 'Satın al' }),
      B('button', { bg: 'white', label: 'Yüzüklere göz at', url: JU('collections/yuzukler') }),
    ],
  },
];

// ── Yorstruly ───────────────────────────────────────────────────────────────
// Segmentler: Shopify → Customer Segments'teki Yorstruly segmentleri (services/brandSegments.js, 26 Eki 2026).
// Dil: sitedeki gibi "siz", sakin ve özenli; slogan yok. Ürün bilgisi yalnız yorstruly.com açıklamalarından,
// iade/değişim vaadi sitedeki "45 gün ücretsiz iade" ve "ücretsiz iade ve değişim". İndirim/kod uydurulmadı;
// set fiyatları Shopify'daki karşılaştırma fiyatıyla. Görseller: sitedeki kampanya fotoğrafları (LIFE).
const YORS_ID = '443c357b-fde2-434e-bb19-34b7898d4576';
const YIMG = `https://api.glowytics.com/pixel/glowymail/${YORS_ID}/`;
const YU = (path) => `https://yorstruly.com/${path}`;
const YORS_RED = '#851f2d';  // sitedeki "Hemen keşfet" butonu

export const YORSTRULY_THEME = {
  ...DEFAULT_THEME,
  logo: `${YIMG}yorstruly-logo-dark.png`,
  logoFooter: `${YIMG}yorstruly-logo-white.png`,
  logoWidth: 140,
  homeUrl: YU(''),
  ink: '#111111',
  soft: '#f3f1ec',
  muted: '#77736d',
  line: '#e4e1da',
  accent: '#111111',
  radius: 0,
  headFont: 'Maven Pro',
  uppercaseHeadings: true,
  headTracking: 4,
  buttonStyle: 'outline',
  footerStyle: 'light',
  pageBg: '#ebe8e2',
  nav: [{ label: 'Yeni', url: YU('collections/yeni-gelenler') }, { label: 'Bestsellers', url: YU('collections/bestseller') }, { label: 'Tayt', url: YU('collections/tayt') }, { label: 'Büstiyer', url: YU('collections/bustiyer') }],
  footerLinks: [{ label: 'Instagram', url: 'https://www.instagram.com/yorstruly/' }, { label: 'yorstruly.com', url: YU('') }],
  footerText: "Ücretsiz iade ve değişim.\nBu e-postayı yorstruly.com'dan ticari ileti almayı kabul ettiğiniz için alıyorsunuz.",
};

const YP = (k) => clone(YPR[k]);
const yitems = (...pairs) => pairs.map(([k, label]) => ({ item: YP(k), label: label || '' }));
const ED = (title, items, bg = 'white') => B('products', { bg, layout: 'editorial', title, items, buyLabel: 'İncele' });
const SETS_SPLIT = (side, bg) => B('split', { bg, src: YLIFE.TRIO_TALL.tall, side, eyebrow: 'Yors Sets', title: 'Bra ve tayt\nbir arada', text: 'Setlerde bra ve tayt birlikte, ayrı ayrı alındığında olduğundan daha uygun fiyatla sunuluyor.', link: { label: 'Setleri inceleyin', url: YU('collections/yors-sets') } });
const SETS = () => ED('', yitems(['SET1', 'BLOOM BRA + RISER'], ['SET5', 'CUT OUT BRA + MERROW']));

const YORSTRULY = [
  {
    key: 'ikinci-siparis', name: '01 Yaşam döngüsü: İkinci sipariş', group: 'Lifecycle · Second-order window (754)',
    subject: 'Yorstruly’de en çok tercih edilenler', preheader: 'Beden tablosu, ücretsiz değişim ve 45 gün içinde ücretsiz iade',
    blocks: () => [
      B('cover', { bg: 'white', src: YLIFE.LOFT.cover, eyebrow: 'Yorstruly', title: 'Sizin için\nseçtiklerimiz', text: "{{first_name|Merhaba}}, ilk siparişiniz için teşekkür ederiz. Son üç ayda en çok tercih edilen parçaları sizin için bir araya getirdik.", link: { label: 'Bestsellers', url: YU('collections/bestseller') }, titleSize: 32 }),
      ED('En çok tercih edilenler', yitems(['TWIST_LEO'], ['COCO_MERLOT'], ['STUDIO_LEO'], ['RISER_MERLOT'])),
      B('steps', { bg: 'soft', title: 'Alışverişinizi kolaylaştıran ayrıntılar', items: [
        { title: 'Beden tablosu', text: 'Her ürün sayfasında modelin ölçüleri ve giydiği beden yer alıyor.' },
        { title: 'Ücretsiz değişim', text: 'Bedeni ya da rengi değiştirmek isterseniz değişim ücretsizdir.' },
        { title: '45 gün içinde ücretsiz iade', text: 'Beklediğiniz gibi olmayan ürünü 45 gün içinde ücretsiz iade edebilirsiniz.' }] }),
      B('button', { bg: 'soft', label: 'Tüm koleksiyon', url: YU('collections/tum-urunler') }),
    ],
  },
  {
    key: 'bra-tayt', name: '02 Çapraz satış: Bra alanlara tayt', group: 'Cross-sell · Bra buyers, no leggings (2.635)',
    subject: 'Bra’nızla aynı renkte taytlar', preheader: 'Birlikte tasarlanan parçalar ve hazır setler',
    blocks: () => [
      B('cover', { bg: 'white', src: YLIFE.TRIO_WIDE.cover, eyebrow: 'Takım', title: 'Birlikte\ntasarlandı', text: "Bugüne kadar Yorstruly'den bra tercih ettiniz; en son {{son_bra|Skinny Bra}}. Bra'larımızın birçoğu aynı renkteki taytlarla birlikte tasarlandı.", link: { label: 'Taytlar', url: YU('collections/tayt') }, titleSize: 32 }),
      ED('Aynı renkte taytlar', yitems(['RISER_MERLOT', 'MERLOT'], ['MERROW_EB', 'ELECTRIC BLUE'], ['TWIST_GANACHE', 'CHOCOLATE GANACHE'], ['MERROW_LEO', 'LEOPARD'])),
      SETS_SPLIT('left', YORS_RED),
      SETS(),
    ],
  },
  {
    key: 'tayt-bra', name: '03 Çapraz satış: Tayt alanlara bra', group: 'Cross-sell · Leggings buyers, no bra (3.104)',
    subject: 'Taytınızla aynı renkte bra’lar', preheader: 'Birlikte tasarlanan parçalar ve hazır setler',
    blocks: () => [
      B('cover', { bg: 'white', src: YLIFE.GANACHE_WIDE.cover, eyebrow: 'Takım', title: 'Birlikte\ntasarlandı', text: "Bugüne kadar Yorstruly'den tayt tercih ettiniz; en son {{son_tayt|Riser Leggings}}. Taytlarımızın birçoğunun aynı renkte bir bra'sı bulunuyor.", link: { label: "Bra'lar", url: YU('collections/bustiyer') }, titleSize: 32 }),
      ED('Aynı renkte bra’lar', yitems(['COCO_MERLOT', 'MERLOT'], ['BLOOM_EB', 'ELECTRIC BLUE'], ['GAIA_GANACHE', 'CHOCOLATE GANACHE'], ['GAIA_LEO', 'LEOPARD'])),
      B('split', { bg: 'soft', src: YLIFE.COCO.tall, side: 'right', eyebrow: 'Destek', title: 'Kullanımınıza\ngöre', text: "**Coco** hafif tutuculukta, astarlı ve çıkarılabilir destekli. **Bloom** göğsü kavrayan yüksek destekli formuyla antrenmanlar için.", link: { label: "Tüm bra'lar", url: YU('collections/bustiyer') } }),
      SETS_SPLIT('left', YORS_RED),
      SETS(),
    ],
  },
  {
    key: 'mayodan-sonra', name: '04 Sezon: Yalnız mayo alanlara yeni sezon', group: 'Swim only · Early-summer swim buyers, nothing else (645)',
    subject: 'Yorstruly’de yeni sezon', preheader: 'Yoga, pilates, yürüyüş ve gün içi için tasarladıklarımız',
    blocks: () => [
      B('split', { bg: 'soft', src: YLIFE.SUMMER.tall, side: 'left', eyebrow: 'Bu yaz', title: 'Mayonun\nötesinde', text: "Bu yaz Yorstruly'den mayo tercih ettiniz. Mayonun yanında yoga, pilates, yürüyüş ve gün içi için tasarladığımız bir koleksiyonumuz da var.", link: { label: '', url: '' } }),
      B('cover', { bg: 'white', src: YLIFE.LOFT.cover, eyebrow: 'Yeni sezon', title: 'Hareket için\ntasarlandı', text: '**Twist Flare** dizlere kadar sarıp ardından genişleyen yüksek bel kesimiyle yoga, pilates ve yürüyüş için. **Studio Pants** modal elyaftan; çabuk kuruyor, ütü gerektirmiyor.', link: { label: 'ACTIVE koleksiyonu', url: YU('collections/active') }, titleSize: 32 }),
      ED('', yitems(['TWIST_GANACHE', 'FLARE'], ['STUDIO_MERLOT', 'BOL KESİM'], ['BLOOM_EB', 'SPOR BRA'], ['CURVE_MERLOT', 'MERİNO'])),
      B('button', { bg: 'white', label: 'Yeni gelenler', url: YU('collections/yeni-gelenler') }),
    ],
  },
  {
    key: 'yeni-gelenler', name: "05 Geri kazanım: Risk altındaki VIP'ler", group: 'Win-back · VIP at risk: 3+ orders, 9+ months quiet (1.053)',
    subject: 'Son siparişinizden bu yana gelenler', preheader: 'Merino ailesi, Chocolate Ganache ve Butter Polo',
    blocks: () => [
      B('cover', { bg: 'white', src: YLIFE.GANACHE_OFF.cover, eyebrow: 'Yeni gelenler', title: 'Son siparişinizden\nbu yana', text: "En son {{son_siparis_ay|Ocak}} ayında Yorstruly'den alışveriş yaptınız. O günden bu yana koleksiyona yeni parçalar eklendi; birkaçını sizin için seçtik.", link: { label: 'Yeni gelenler', url: YU('collections/yeni-gelenler') }, titleSize: 30 }),
      ED('', yitems(['JUMP_GANACHE'], ['BALLET_WRAP_GANACHE'], ['POLO_NAVY'], ['CURVE_MERLOT'])),
      B('split', { bg: 'soft', src: YLIFE.HOODIE.tall, side: 'right', eyebrow: 'Merino', title: 'Merino\nailesi', text: 'Doğal merino kumaş hava aldırır ve sıcak tutar; antrenmanda da gün içinde de katman olarak giyilebilir.', link: { label: 'Merino koleksiyonu', url: YU('collections/merino') } }),
    ],
  },
  {
    key: 'kasim', name: '06 Sezon: Kasım alıcıları', group: 'Seasonal · November-only buyers (763)',
    subject: 'Leopard serisi ve Merlot tonları', preheader: 'Bu sezon en çok tercih edilen parçalar',
    blocks: () => [
      B('cover', { bg: 'white', src: YLIFE.LEOPARD.cover, eyebrow: 'Leopard serisi', title: 'Bu sezon en çok\ntercih edilenler', text: "Daha önce Kasım ayında Yorstruly'yi tercih ettiniz. Bu sezon en çok ilgi gören parçaları sizin için bir araya getirdik.", link: { label: 'Leopard serisi', url: YU('collections/leopard-series') }, titleSize: 30 }),
      ED('', yitems(['TWIST_LEO'], ['GAIA_LEO'], ['STUDIO_LEO'], ['MERROW_LEO'])),
      B('split', { bg: YORS_RED, src: YLIFE.COCO.tall, side: 'left', eyebrow: 'AW 26/27', title: 'Merlot', text: "Coco Bra ve Riser 7/8 Leggings, AW 26/27 koleksiyonunun Merlot tonunda.", link: { label: 'AW 26/27 koleksiyonu', url: YU('collections/aw-26-27') } }),
      ED('', yitems(['COCO_MERLOT'], ['RISER_MERLOT'])),
    ],
  },
  {
    key: 'sadakat', name: '07 Sadakat: Teşekkür', group: 'Loyalty · Loyal & active, 5+ orders (414)',
    subject: 'Teşekkür ederiz', preheader: 'Bu sezon merino ailesine eklenenler',
    blocks: () => [
      B('cover', { bg: 'white', src: YLIFE.MERLOT_OFF.cover, eyebrow: 'Yorstruly', title: 'Teşekkür\nederiz', text: "{{first_name|Merhaba}}, bugüne kadar Yorstruly'den {{siparis_sayisi|5}} sipariş verdiniz. Bu sezon merino ailesine yeni parçalar ekledik; beğeneceğinizi düşündüklerimizi seçtik.", link: { label: 'Merino koleksiyonu', url: YU('collections/merino') }, titleSize: 32 }),
      ED('Merino ailesi', yitems(['CURVE_MERLOT'], ['BALLET_TOP_MERLOT'], ['OFFSH_GANACHE'], ['LEG_WARM'])),
      B('steps', { bg: 'soft', title: 'Merino hakkında', items: [
        { title: 'Doğal lif', text: '%100 doğal yapısıyla hava aldırır ve sıcak tutar.' },
        { title: 'Katman olarak', text: 'İç katmanda da dış katmanda da konfor sağlar.' },
        { title: 'Gün boyu', text: 'Koşu, yürüyüş, yoga sonrası ya da şehirde.' }] }),
    ],
  },
  {
    key: 'beden', name: '08 Beden: Bedeninde stokta olanlar', group: 'Size · Confirmed size, 2+ orders same size (416)',
    subject: '{{beden|S}} bedeninde stokta olan parçalar', preheader: 'Siparişlerinizde tercih ettiğiniz bedende şu an stokta olanlar',
    blocks: () => [
      B('cover', { bg: 'white', src: YLIFE.BACK.cover, eyebrow: 'Bedeniniz', title: '{{beden|S}} bedeninde\nstokta', text: 'Son iki yıldaki siparişlerinizde hep {{beden|S}} bedeni tercih ettiniz. Aşağıdaki parçaların tümü şu an {{beden|S}} bedende stokta.', link: { label: '', url: '' }, titleSize: 30 }),
      ED('', yitems(['BLOOM_EB'], ['JUMP_GANACHE'], ['GAIA_GANACHE'], ['STUDIO_MERLOT'])),
      SETS_SPLIT('right', 'soft'),
      SETS(),
    ],
  },
];

const BLANK = {
  key: 'blank', name: 'Untitled email', group: 'Start from scratch', subject: '', preheader: '',
  blocks: () => [
    B('hero', { bg: 'white', eyebrow: 'Yeni sezon', title: 'Başlık buraya', text: 'Kısa bir açıklama yaz.', button: { label: 'Alışverişe başla', url: '' }, titleSize: 46 }),
    B('products', { bg: 'white', title: 'Senin için seçtik', items: [], buyLabel: 'Satın al' }),
  ],
};

const BRAND_SETS = {
  [KIXZ_ID]: { starters: KIXZ, theme: KIXZ_THEME },
  [JUJU_ID]: { starters: JUJU, theme: JUJU_THEME },
  [YORS_ID]: { starters: YORSTRULY, theme: YORSTRULY_THEME },
};

export function startersFor(brandId) {
  return [BLANK, ...(BRAND_SETS[brandId]?.starters || [])];
}

export function themeFor(brandId) {
  return clone(BRAND_SETS[brandId]?.theme || DEFAULT_THEME);
}

export function docFromStarter(s, brandId) {
  return { theme: themeFor(brandId), blocks: s.blocks() };
}
